module.exports = __webpack_public_path__ + "fwm_h5/img/a2202ejiaopian.d9178d42.jpg";